var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tabs',{attrs:{"show-arrows":"","data-tour":"tabs"}},_vm._l((_vm.tabs),function(tab){return _c('v-tab',{key:tab.path,attrs:{"to":tab.path,"exact":tab.exact,"data-tour":`tab-${tab.key}`}},[_c('v-icon',{attrs:{"small":"","left":""}},[_vm._v(_vm._s(tab.icon))]),_vm._v(" "+_vm._s(tab.text)+" ")],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }